/* istanbul ignore file */
import {
  makeStyles, tokens, typographyStyles, shorthands,
} from '@fluentui/react-components';

export const usePrimaryNavigationStyles = makeStyles({
  root: {
    height: '100%',
    backgroundColor: tokens.colorNeutralBackground4,
  },
  rootDetailed: {
    width: '69px',
  },
  rootIconOnly: {
    width: '49px',
  },
  container: {
    display: 'flex',
    height: '100%',
    backgroundColor: tokens.colorNeutralBackground4,
    ...shorthands.overflow('hidden'),
    ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalXXS),
    ...shorthands.borderRight(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: tokens.spacingHorizontalXXS,
    paddingRight: tokens.spacingHorizontalXXS,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,

    '&::after, &::before': {
      width: tokens.strokeWidthThick,
    },

    '& > span': {
      ...typographyStyles.caption2,
    },

    '&.nav-item-unpinned-selected span.side-navigation-item-text': {
      fontStyle: 'italic',
    },

    '& span.side-navigation-item-text': {
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical',
      ...shorthands.overflow('hidden'),
      wordBreak: 'break-word',
      hyphens: 'auto',
    },

    '& .fui-Tab__icon': {
      width: '24px',
      height: '24px',
    },

    '&.side-navigation-item-button:hover': {
      '& > span': { color: tokens.colorNeutralForeground3BrandHover },
    },

    '&.side-navigation-item-button:focus': {
      '& > span': { color: tokens.colorNeutralForeground3BrandHover },
    },

    '&.nav-item-primary': {
      marginLeft: tokens.spacingHorizontalXXS,
      backgroundColor: tokens.colorBrandBackground,
      paddingTop: tokens.spacingVerticalXXS,
      paddingBottom: tokens.spacingVerticalXXS,
      '& > span': { color: tokens.colorNeutralForegroundOnBrand },

      '&:hover, &:focus': {
        backgroundColor: tokens.colorBrandBackgroundHover,
        '& > span': { color: tokens.colorNeutralForegroundOnBrand },
        '&::before': { backgroundColor: tokens.colorBrandBackgroundHover },
      },

      '&:active': {
        backgroundColor: tokens.colorBrandBackgroundPressed,
        '& > span': { color: tokens.colorNeutralForegroundOnBrand },
        '&::before': { backgroundColor: tokens.colorBrandBackgroundPressed },
      },
    },
  },
  menuItemDetailed: {
    width: '64px',
    minHeight: '54px',
    display: 'flex',
    justifyContent: 'center',
    '&.nav-item-primary': {
      width: '60px',
      minHeight: '48px',
    },
  },

  menuItemIconOnly: {
    width: '44px',
    height: '44px',
    display: 'flex',
    justifyContent: 'center',
    '&.nav-item-primary': {
      width: '40px',
      height: '40px',
    },
  },
});
